/**
 * Client-side auth field validation for the login page.
 * Password is never collected here (OIDC PKCE → Keycloak).
 */

export type UsernameIssue = 'required' | 'too-short' | 'invalid'

const EMAILish = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const USERish = /^[a-zA-Z0-9._-]{3,64}$/

export function normalizeUsername(raw: string): string {
  return raw.trim()
}

export function validateUsername(raw: string): UsernameIssue | null {
  const value = normalizeUsername(raw)
  if (!value) return 'required'
  if (value.length < 3) return 'too-short'
  if (value.includes('@')) {
    if (!EMAILish.test(value) || value.length > 254) return 'invalid'
    return null
  }
  if (!USERish.test(value)) return 'invalid'
  return null
}

export function usernameErrorMessage(issue: UsernameIssue): string {
  switch (issue) {
    case 'required':
      return 'Enter your username or email to continue.'
    case 'too-short':
      return 'Use at least 3 characters.'
    case 'invalid':
      return 'Enter a valid username or email address.'
  }
}

/** Soft client lock after repeated invalid submits (credential-stuffing UX). */
export const LOGIN_ATTEMPT_LIMIT = 5
export const LOGIN_LOCK_MS = 30_000
